import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { api } from '../../api';
import { Callout } from '../../components/blocks';
import { DataError } from '../../components/DataError';
import { PageHeader, useDocumentTitle } from '../../components/PageHeader';
import { EmptyState, Loading } from '../../components/States';
import { useApi } from '../../lib/useApi';
import { PendingChangesPanel, PROVIDER_CHANGE_KINDS } from './changes';
import { DeploymentNote, useIntegrationContext, WithIntegrationContext } from './shared';
import { ProviderPanel } from './VnnicPage';

/**
 * Cài đặt › Kết nối › Chống robot: Cloudflare Turnstile, the anti-robot check of the client sign-in
 * forms (sign-in, sign-up, forgotten password, new password, accepting an invitation). The site key,
 * the secret key (stored encrypted, never shown again), when to ask, on / off; "Kiểm tra kết nối"
 * asks Cloudflare whether it accepts the secret key.
 */
export function CaptchaPage() {
  const { t } = useTranslation('integrations');
  useDocumentTitle(t('provider.tab.CLOUDFLARE_TURNSTILE'));
  return (
    <>
      <PageHeader title={t('provider.name.CLOUDFLARE_TURNSTILE')} subtitle={t('provider.description.CLOUDFLARE_TURNSTILE')} />
      <WithIntegrationContext>
        <CaptchaView />
      </WithIntegrationContext>
    </>
  );
}

function CaptchaView() {
  const { t } = useTranslation('integrations');
  const ctx = useIntegrationContext();
  const [tick, setTick] = useState(0);
  const catalog = useApi((signal) => api.getProviderCatalog({ signal }), []);
  const reload = () => setTick((n) => n + 1);
  const def = catalog.status === 'success' ? catalog.data.providers.find((p) => p.provider === 'CLOUDFLARE_TURNSTILE') : undefined;
  return (
    <div className="space-y-6" data-captcha-page>
      <DeploymentNote providers />
      <Callout tone="info" title={t('captcha.howTitle')}>
        <ul className="list-disc space-y-1 pl-5">
          <li>{t('captcha.forms')}</li>
          <li>{t('captcha.when')}</li>
          <li>{t('captcha.failClosed')}</li>
          <li>{t('captcha.lock')}</li>
          <li>{t('captcha.staff')}</li>
        </ul>
      </Callout>
      <PendingChangesPanel kinds={PROVIDER_CHANGE_KINDS} refreshKey={tick} onChanged={reload} />
      {catalog.status === 'error' ? <DataError error={catalog.error} onRetry={catalog.reload} title={t('vnnic.catalogFailed')} /> : null}
      {catalog.status === 'loading' ? <Loading rows={3} /> : null}
      {catalog.status === 'success' ? def ? <ProviderPanel def={def} env={ctx.integration_environment} tick={tick} onChanged={reload} /> : <EmptyState title={t('vnnic.unknownProvider')} /> : null}
    </div>
  );
}
